import React from "react";
import Modal from "react-modal";
import LoadingIndicator from "./LoadingIndicator";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "unset",
    border: "unset",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    backgroundColor: "transparent",
    borderRadius: ".5rem",
  },
};

Modal.setAppElement("#root");

const ModalLoading = ({
  modalIsOpen,
  closeModal,
  title,
  subtitle,
  message,
  shouldCloseOnOverlayClick,
  shouldCloseOnEsc,
  remove,
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel={title}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
    >
      <div
        className="bg-white rounded-lg overflow-hidden border-gray-200 border transform transition-all sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div className="sm:flex sm:items-start">
            <div className="mt-3 text-center sm:mt-0 sm:text-left">
              <div className="mt-2">
                <LoadingIndicator message={title}></LoadingIndicator>
                <p className="text-sm leading-5 text-gray-700 text-center">
                  {message}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLoading;
